import { PUBLIC_URL } from '../../__common/env';
import { IoClose } from 'react-icons/io5';
import { observer } from 'mobx-react-lite';
import { HeaderButtons } from './HeaderButtons';
import ScaleInput from './ScaleInput';
import { useMainContext } from '../../hooks/useMainContext';
import UnitButton from './UnitButton';
import ClosetButton from './ClosetButton';
import UserMenu from './UserMenu';

export const Header = observer(() => {
    const { viewManager } = useMainContext();

    function clearQueryParams() {
        const url = new URL(window.location.href);
        url.search = '';
        window.history.pushState({}, '', url);
    }

    return (
        <div className="flex justify-between items-center w-full h-[56px] bg-theme-header-bg border-[1px] border-theme-button-bg ">
            <div className="flex">
                <div
                    className="h-[54px] w-[56px] bg-theme-white flex justify-center items-center border-r-[1px] border-theme-button-bg cursor-pointer"
                    onClick={() => {
                        clearQueryParams();
                        window.location.reload();
                    }}>
                    <img
                        src={`${PUBLIC_URL}/assets/icons/home_icon.svg`}
                        className="w-[24px] h-[24px]"
                        alt=""
                    />
                </div>
                {viewManager.currentPage === 'workSpace' && (
                    <>
                        <div className="h-[54px] w-[176px] px-[16px] py-[8px] flex justify-between items-center border-r-[1px] border-theme-button-bg bg-theme-white">
                            <h2 className="font-favorit text-[14px] leading-[16px] text-[#F46147] font-normal">
                                {viewManager.formData?.projectName}
                            </h2>
                            <IoClose
                                className="w-[24px] h-[24px] cursor-pointer text-[#F46147]"
                                onClick={() => {
                                    clearQueryParams();
                                    window.location.reload();
                                }}
                            />
                        </div>
                        {viewManager.selectedMenu === 2 && (
                            <div className="h-[54px] flex items-center ml-[16px] gap-[16px]">
                                <UnitButton />
                                <ClosetButton />
                            </div>
                        )}
                    </>
                )}
                {viewManager.currentPage === 'homePage' && (
                    <div
                        className="h-[56px] w-[56px] flex justify-center items-center cursor-pointer"
                        onClick={() => viewManager.setOpenForm(true)}>
                        <img
                            src={`${PUBLIC_URL}/assets/icons/plus_icon.svg`}
                            className="w-[24px] h-[24px]"
                            alt=""
                        />
                    </div>
                )}
            </div>

            {viewManager.currentPage === 'workSpace' &&
                viewManager.selectedMenu === 2 && <ScaleInput />}
            <div className="flex items-center gap-[16px]">
                {viewManager.currentPage === 'workSpace' && <HeaderButtons />}

                <UserMenu />
            </div>
        </div>
    );
});
